import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo, { crumbsLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/Blocks";
import { GUIDES } from "@/data/guides";

const fmt = (d) => new Date(d).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });

export default function GuidesIndex() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Guide", to: "/guide" }];
  return (
    <>
      <Seo path="/guide" title="Guide su siti web, costi, CRM e presenza online | STUDIO WEB NS"
        description="Guide pratiche per piccole imprese: quanto costa un sito, vetrina o e-commerce, manutenzione, CRM e gestione della presenza online." jsonLd={crumbsLd(crumbs)} />
      <PageHero crumbs={crumbs} eyebrow="Guide" title="Informazioni utili, prima di decidere." intro="Articoli pratici per capire costi, strumenti e scelte della tua presenza digitale. Senza promesse irrealistiche." />
      <section className="py-14 md:py-20">
        <div className="wrap grid gap-5 md:grid-cols-2">
          {GUIDES.map((g) => (
            <Link key={g.slug} to={`/guide/${g.slug}`} data-testid={`guide-card-${g.slug}`} className="card group flex flex-col p-8 transition-[border-color,transform] hover:-translate-y-1 hover:border-slate-900">
              <div className="flex items-center justify-between text-xs text-slate-600">
                <span className="rounded-full bg-blue-50 px-3 py-1 font-semibold text-blue-700">{g.category}</span>
                <span>Aggiornato il {fmt(g.updated)}</span>
              </div>
              <h2 className="mt-6 font-display text-xl font-bold leading-snug">{g.title}</h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{g.excerpt}</p>
              <ArrowUpRight className="mt-6 h-5 w-5 text-slate-300 transition-colors group-hover:text-blue-600" />
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
